import {PublishStatus, RaceStatus, ResultsStatus} from "../../schemas/races/racesSchema";

export const raceStatusLabel: Record<RaceStatus, string> = {
    "PLANNED": "Naplánován",
    "IN_PROGRESS": "Probíhá",
    "FINISHED": "Dokončen",
};

export const raceResultsStatusLabel: Record<ResultsStatus, string> = {
    "PUBLISHED": "Publikováno",
    "UNPUBLISHED": "Nepublikováno",
};

export const racePublishStatusLabel: Record<PublishStatus, string> = {
    "PUBLISHED": "Aktuality",
    "UNPUBLISHED": "Nepublikováno",
    "ANNOUNCED": "Kalendář",
};
